var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"docker-server"},[_c('iframe',{ref:"iframeDom",attrs:{"name":"iframeChild","id":"iframeChild","src":_vm.getPageUrl,"frameborder":"0","scrolling":"auto","sandbox":"allow-same-origin allow-top-navigation allow-forms allow-scripts allow-downloads"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }